import React from "react";

export const DataRoom: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg {...props} width="89" height="75" viewBox="0 0 89 75" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M72.6667 0H14.3333C9.75 0 6 3.75 6 8.33333V66.6667C6 71.25 9.75 75 14.3333 75H72.6667C77.25 75 81 71.25 81 66.6667V8.33333C81 3.75 77.25 0 72.6667 0ZM72.6667 66.6667H14.3333V8.33333H72.6667V66.6667ZM22.6667 29.1667H31V58.3333H22.6667V29.1667ZM39.3333 16.6667H47.6667V58.3333H39.3333V16.6667ZM56 41.6667H64.3333V58.3333H56V41.6667Z" fill="currentColor"/>
</svg>
);
